import { render, staticRenderFns } from "./roler.vue?vue&type=template&id=85749fc4&"
import script from "./roler.vue?vue&type=script&lang=js&"
export * from "./roler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports